import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import TopicPostsList from './TopicPostsList';

const queryClient = new QueryClient();

const TopicForumPosts = ({ topic }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <TopicPostsList topic={topic} />
    </QueryClientProvider>
  );
};

export default TopicForumPosts;
